<template lang="pug">
  .polar
    #polar
    #networkChart
</template>
<script>
import * as d3 from "d3"

export default {
  name: "Polar",
  data() {
    return {
      data: {
        "nodes": [
          {"id": "Fantine", "group": 10},
          {"id": "Marguerite", "group": 3},
          {"id": "Tholomyes", "group": 3},
          {"id": "Listolier", "group": 3},
          {"id": "Fameuil", "group": 3},
          {"id": "Blacheville", "group": 3},
          {"id": "Favourite", "group": 1},
          {"id": "Dahlia", "group": 1},
          {"id": "Zephine", "group": 2},
          {"id": "Perpetue", "group": 2},
          {"id": "Simplice", "group": 2},
        ],
        "links": [
          {"source": "Listolier", "target": "Tholomyes", "value": 5},
          {"source": "Fameuil", "target": "Tholomyes", "value": 5},
          {"source": "Blacheville", "target": "Fameuil", "value": 4},
          {"source": "Favourite", "target": "Tholomyes", "value": 3},
          {"source": "Dahlia", "target": "Tholomyes", "value": 3},
          {"source": "Dahlia", "target": "Fameuil", "value": 3},
          {"source": "Dahlia", "target": "Blacheville", "value": 3},
          {"source": "Zephine", "target": "Favourite", "value": 4},
          {"source": "Zephine", "target": "Dahlia", "value": 4},
          {"source": "Fantine", "target": "Tholomyes", "value": 3},
          {"source": "Fantine", "target": "Listolier", "value": 3},
          {"source": "Fantine", "target": "Fameuil", "value": 3},
          {"source": "Fantine", "target": "Blacheville", "value": 3},
          {"source": "Fantine", "target": "Favourite", "value": 4},
          {"source": "Fantine", "target": "Dahlia", "value": 4},
          {"source": "Fantine", "target": "Zephine", "value": 1},
          {"source": "Fantine", "target": "Marguerite", "value": 2},
          {"source": "Fantine", "target": "Perpetue", "value": 1},
          {"source": "Simplice", "target": "Perpetue", "value": 2},
          {"source": "Simplice", "target": "Fantine", "value": 2},
        ]
      },
      colors: {
        "Estado": "#126aaa",
        "Municipio": "#ff0303",
        "Partido municipal": "#ffb11f",
        "Publicación": "#1fadff",
        "Plataforma": "#79232c"
      },
      width: 600,
      height: 600,
      nodes: [],
      links: [],
      clusters: []
    }
  },
  computed: {
    allJournalists() {
      return this.$store.state.allJournalists;
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      }
    }
  },
  methods: {
    drawChart() {
      let reMap = function(oldValue) {
        let oldMin = 0,
            oldMax = -359,
            newMin = 0,
            newMax = (Math.PI * 2),
            newValue = (((oldValue - 90 - oldMin) * (newMax - newMin)) / (oldMax - oldMin)) + newMin;
        
        return newValue;
      }

      let data = [
        [reMap(180), 1, 10, 'label 1'],
        [reMap(105), 2, 10, 'label 2'],
        [reMap(266), 3, 10, 'label 3'],
        [reMap(8), 4, 10, 'label 4'],
        [reMap(-90), 5, 10, 'label 5'],
        [reMap(350), 6, 10, 'label 6'],
        [reMap(119), 4, 10, 'label 7'],
        [reMap(305), 3, 10, 'label 8']
      ];

      let width = 600,
        height = 600,
        radius = Math.min(width, height) / 2 - 30;

      let r = d3.scaleLinear()
        .domain([0, data.length])
        .range([0, radius]);

      d3.select('#polar svg').remove();

      let svg = d3.select('#polar').append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

      let gr = svg.append('g')
        .attr('class', 'r axis')
        .selectAll('g')
        .data([1,2,3,4,5,6])
        .enter().append('g');

      gr.append('circle')
        .attr('r', r)
        .style('fill', 'none')
        .style('stroke','#aaa');
        
      let color = "#000";

      let line = d3.lineRadial()
        .radius(d => r(d[1]))
        .angle(d => -d[0] + Math.PI / 2);

      let indexLabel = svg.append('g')
        .attr('class', 'index label')
        .selectAll('g')
        .data([1,2,3,4,5,6])
        .enter()
        .append('g');

      indexLabel.append('circle')
        .attr('r', 8)
        .attr('transform', (d,i) => 'translate('+line([[reMap(-110), i+1]]).slice(1).slice(0, -1)+')')
        .style('fill', 'none')
        .style('stroke','#000');

      indexLabel.append('text')
        .attr('x', '0')
        .attr('y', '4')
        .attr('text-anchor', 'middle')
        .attr('transform', (d,i) => 'translate('+line([[reMap(-110), i+1]]).slice(1).slice(0, -1)+')')
        .style('font-size', '10')
        .text((d,i) => i + 1);

      const pointRadius = 6;

      svg.selectAll('point')
        .data(data)
        .enter()
        .append('circle')
        .attr('class', 'point')
        .attr('transform', d => {
          var coors = line([d]).slice(1).slice(0, -1); // removes 'M' and 'Z' from string
          return 'translate(' + coors + ')'
        })
        .attr('r', pointRadius)
        .attr('fill', '#920D00')
        .on("click",  d => {
          console.log(d);          
        })
        .on("mouseover", function(d, i) {
          d3.select(this)
            .attr('fill', '#920D00')
            .attr('r', 70)
            .style('cursor','pointer');
          d3.select(this.parentNode).moveToFront();            
        })
        .on("mouseout", function(d, i) {
          d3.select(this)
            .transition()
            .duration(250)
            .attr('fill', '#920D00')
            .attr('r', 6)
            .style('cursor', null);
          });
    },
    getNodes(selection, all) {
      const state = selection["Estado de asesinato"],
            mun = selection["Municipio de asesinato"],
            munparty = selection["Partido político Presidente municipal"],
            media = selection["Medio"],
            name = selection["Nombre"];
      
      const nodes = [];
      all.forEach(j => {
        const otherstate = j["Estado de asesinato"],
              othermun = j["Municipio de asesinato"],
              othermunparty = j["Partido político Presidente municipal"],
              othermedia = j["Medio"];
        /* let node = {
          group: [],
          id: j["Nombre"]
        }   */
        let node = j;  
        node.group = [];
        node.id = j["Nombre"];

        if (otherstate == state && state) node.group.push("Estado");
        if (othermun == mun && mun) node.group.push("Municipio");
        if (othermunparty == munparty && munparty) node.group.push("Partido municipal");
        if (othermedia == media && media) node.group.push("Publicación");

        if (node.group.length > 0 && node.id !== name) {  
          nodes.push(node);
        }
      });
      nodes.unshift({group: [], id: selection["Nombre"]});
      return nodes;
    },
    getLinks() {
      const nodes = this.nodes.slice();
      this.links = [];
      nodes.forEach(n => {
        for (let i = 0; i < n.group.length; i++) {
          const link = {
            source: nodes[0].id,
            target: n.id,
            value: n.group[i]
          }
          this.links.push(link);
        }
      });
      //const nodes = this.nodes.slice();
      //this.links = [];
  
      nodes.forEach((n, i) => {
        const childNodes = this.getNodes(n, this.nodes.slice(i));
        childNodes.forEach(n => {
          for (let i = 0; i < n.group.length; i++) {
            const link = {
              source: childNodes[0].id,
              target: n.id,
              value: n.group[i]
            }
            this.links.push(link);
          }
        });
      });

    },
    async networkData() {
      this.nodes = await this.getNodes(this.selectedJournalist, this.allJournalists);
      let cluster = new Set();
      this.nodes.forEach(el => cluster = new Set([...cluster, ...el.group]));
      this.clusters = Array.from(cluster);
      this.getLinks();
    },
    async drawNetwork() {
      /* Node drag disabled 
      let drag = simulation => {
        function dragstarted(d) {
          if (!d3.event.active) simulation.alphaTarget(0.3).restart();
          d.fx = d.x;
          d.fy = d.y;
        }
        
        function dragged(d) {
          d.fx = d3.event.x;
          d.fy = d3.event.y;
        }
        
        function dragended(d) {
          if (!d3.event.active) simulation.alphaTarget(0);
          d.fx = null;
          d.fy = null;
        }
        
        return d3.drag()
            .on("start", dragstarted)
            .on("drag", dragged)
            .on("end", dragended);
      } */
      const data = this.data,
            links = this.links,//data.links,
            nodes = this.nodes,//data.nodes,
            radius = 12,
            coordinates = this.radialPlacement(nodes);

      const simulation = d3.forceSimulation(nodes)
        .force("link", d3.forceLink(links).id(d => d.id))
        .force("charge", d3.forceManyBody())
        .force("center", d3.forceCenter(this.width / 2, this.height / 2))
        .force('collision', d3.forceCollide().radius(d => d.radius));

      d3.selectAll('#networkChart svg').remove();
      let svg = d3.select('#networkChart').append('svg')
        .attr('width', this.width)
        .attr('height', this.height);

      const link = svg.append("g")
          .attr("stroke", "#999")
          .attr("stroke-opacity", 0.6)
        .selectAll("line")
        .data(links)
        .join("line")
          .attr("stroke-width", "2")//d => Math.sqrt(d.value))
          .attr("stroke", d =>{//console.log(d, 'color');
          return this.colors[d.value]});

      const wholeNode = svg.selectAll(".nodes")
        .data(nodes)
        .enter()
        .append("g")
          .attr("class", "nodes");

      const node = wholeNode.append("circle")
          .attr("r", (d, i) => i == 0 ? 60 : radius)
          .attr("fill", "#920D00")
          .attr("stroke", "none");

      wholeNode.append("text")
          .text(d => d.id)
          .attr("text-anchor", (d, i) => i == 0 ? "middle" : d.value.x > this.width / 2 ? "start" : "end")
          .attr("transform", (d, i) => {
            const x = d.value.x,
                  y = d.value.y;
            if (i == 0)
              return "translate(" + x + "," + y + ")";
            else if (x > this.width / 2)
              return "translate(" + (x + radius) + "," + (y - radius / 2) + ")";
            else
              return "translate(" + (x - radius - 3) + "," + (y) + ")";
          })
          .style("font-size", (d, i) => i == 0 ? 15 : 11)
          .attr("fill", (d, i) => i == 0 ? "#fff" : "#000");

      simulation.on("tick", function() {
        let alpha = this.alpha();
        
        // draw with simulation
        nodes.forEach((n, i) => {
          if (i > 0) {
            let k = alpha * 0.1;
            n.x = n.value.x - n.x * k;
            n.y = n.value.y - n.y * k;
          }
          else { n.x = 300; n.y = 300 }
        });

        node
          .attr("cx", (d, i) => d.x)
          .attr("cy", (d, i) =>  d.y);
          
        // links are drawn til the end of the simulation
        if (alpha < 0.03) {
          this.stop();
          link
            .attr("x1", d => d.source.value.x)
            .attr("y1", d => d.source.value.y)
            .attr("x2", d => d.target.value.x)
            .attr("y2", d => d.target.value.y);
        }
      });

      // uncomment if drag n drop is active
      //invalidation.then(() => simulation.stop());
      return svg.node();
    },
    radialPlacement(arr) {
      /* const keys = d3.nest()
              .key(d => d.group)
              .entries(arr.slice(1)),
            center = [this.width / 2, this.height / 2],
            clusterStep = 360 / (keys.length),
            step = 10,
            radius = 220; */
      const keys = this.clusters.map(c => {
        return {
          key: c,
          values: arr.slice(1).filter(el => el.group[0] == c)
        }
      })
      const center = [this.width / 2, this.height / 2],
            clusterStep = 360 / (keys.length),
            step = 10,
            radius = 220;

      let coordinates = {},
          current = -80;

      // cluster placement
      keys.forEach((k, i) => {
        let x = center[0] + radius *  Math.cos(current * Math.PI / 180);
        let y = (center[1] + radius * Math.sin(current * Math.PI / 180))
        coordinates[k.key] = {x: x, y: y, angle: current, values: k.values.map(v => v.id)};

        current += clusterStep;
      })
      
      /**
       * 
       * Position nodes around cluster in a perfect circle
       * 
       * */ 
      arr.forEach((a, i) => {
        if (i !== 0) {
          const startPoint = coordinates[a.group[0]].angle,
                order = coordinates[a.group[0]].values.indexOf(a.id),
                x = center[0] + radius *  Math.cos((startPoint + step * order) * Math.PI / 180),
                y = (center[1] + radius * Math.sin((startPoint + step * order) * Math.PI / 180));
          a.value = {x: x, y: y};
        }
        else a.value = {x: center[0], y: center[1]};
      })
      
      //console.log(arr, coordinates);
      return coordinates;
    }
  },
  async mounted() {
    await this.networkData();

    if (window.innerWidth >= 768) this.drawNetwork();
    window.onresize = () => {
      if (window.innerWidth >= 768) this.drawNetwork();
    }
  }
}
</script>